import { ISearchWidget } from 'features/search-widget';

const hotelsSearchWidgetConfig: Record<string, ISearchWidget> = {
  'au-hcom': {
    branding: {
      logo: {
        url: 'https://au.hotels.com/_dms/header/logo.svg?siteid=300000035&locale=en_AU&3ec60977',
        description: 'Hotels.com AU',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'au.hotels.com',
      searchParams: {
        pos: 'HCOM_AU',
        locale: 'en_AU',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'br-hcom': {
    branding: {
      logo: {
        url: 'https://www.hoteis.com/_dms/header/logo.svg?siteid=301800003&locale=pt_BR&3ec60977',
        description: 'Hotels.com BR',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.hoteis.com',
      searchParams: {
        pos: 'HCOM_BR',
        locale: 'pt_BR',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'ca-hcom': {
    branding: {
      logo: {
        url: 'https://ca.hotels.com/_dms/header/logo.svg?siteid=300000002&locale=en_CA&3ec60977',
        description: 'Hotels.com CA',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'ca.hotels.com',
      searchParams: {
        pos: 'HCOM_CA',
        locale: 'en_CA',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  // 'de-hcom': {
  //   branding: {
  //     logo: {
  //       url: 'https://de.hotels.com/_dms/header/logo.svg?siteid=300000752&locale=de_DE&3ec60977',
  //       description: 'Hotels.com DE',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'de.hotels.com',
  //     searchParams: {
  //       pos: 'HCOM_DE',
  //       locale: 'de_DE',
  //     },
  //     stays: {
  //       pathname: '/Hotel-Search',
  //     },
  //   },
  // },

  'dk-hcom': {
    branding: {
      logo: {
        url: 'https://da.hotels.com/_dms/header/logo.svg?siteid=300000013&locale=da_DK&3ec60977',
        description: 'Hotels.com DK',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'da.hotels.com',
      searchParams: {
        pos: 'HCOM_DK',
        locale: 'da_DK',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'fi-hcom': {
    branding: {
      logo: {
        url: 'https://fi.hotels.com/_dms/header/logo.svg?siteid=300000018&locale=fi_FI&3ec60977',
        description: 'Hotels.com FI',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'fi.hotels.com',
      searchParams: {
        pos: 'HCOM_FI',
        locale: 'fi_FI',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'fr-hcom': {
    branding: {
      logo: {
        url: 'https://fr.hotels.com/_dms/header/logo.svg?siteid=300000010&locale=fr_FR&3ec60977',
        description: 'Hotels.com FR',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'fr.hotels.com',
      searchParams: {
        pos: 'HCOM_FR',
        locale: 'fr_FR',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  // 'is-hcom': {
  //   branding: {
  //     logo: {
  //       url: 'https://is.hotels.com/_dms/header/logo.svg?siteid=300000024&locale=is_IS&3ec60977',
  //       description: 'Hotels.com IS',
  //     },
  //   },
  //   lobs: [
  //     {
  //       id: 'stays',
  //       type: 'HOTELS',
  //     },
  //   ],
  //   search: {
  //     hostname: 'is.hotels.com',
  //     searchParams: {
  //       pos: 'HCOM_IS',
  //       locale: 'is_IS',
  //     },
  //     stays: {
  //       pathname: '/Hotel-Search',
  //     },
  //   },
  // },

  'jp-hcom': {
    branding: {
      logo: {
        url: 'https://jp.hotels.com/_dms/header/logo.svg?siteid=300000037&locale=ja_JP&3ec60977',
        description: 'Hotels.com JP',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'jp.hotels.com',
      searchParams: {
        pos: 'HCOM_JP',
        locale: 'ja_JP',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'kr-hcom': {
    branding: {
      logo: {
        url: 'https://kr.hotels.com/_dms/header/logo.svg?siteid=300000041&locale=ko_KR&3ec60977',
        description: 'Hotels.com KR',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'kr.hotels.com',
      searchParams: {
        pos: 'HCOM_KR',
        locale: 'ko_KR',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'mx-hcom': {
    branding: {
      logo: {
        url: 'https://www.hoteles.com/_dms/header/logo.svg?siteid=300400003&locale=HCOM_LATAM&3ec60977',
        description: 'Hotels.com MX',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.hoteles.com',
      searchParams: {
        pos: 'HCOM_LATAM',
        locale: 'es_MX',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'no-hcom': {
    branding: {
      logo: {
        url: 'https://no.hotels.com/_dms/header/logo.svg?siteid=300000012&locale=nb_NO&3ec60977',
        description: 'Hotels.com NO',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'no.hotels.com',
      searchParams: {
        pos: 'HCOM_NO',
        locale: 'no_NO',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'se-hcom': {
    branding: {
      logo: {
        url: 'https://sv.hotels.com/_dms/header/logo.svg?siteid=300000011&locale=sv_SE&3ec60977',
        description: 'Hotels.com SE',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'sv.hotels.com',
      searchParams: {
        pos: 'HCOM_SE',
        locale: 'sv_SE',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'tw-hcom': {
    branding: {
      logo: {
        url: 'https://tw.hotels.com/_dms/header/logo.svg?siteid=300000045&locale=zh_TW&3ec60977',
        description: 'Hotels.com TW',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'tw.hotels.com',
      searchParams: {
        pos: 'HCOM_TW',
        locale: 'zh_TW',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'uk-hcom': {
    branding: {
      logo: {
        url: 'https://uk.hotels.com/_dms/header/logo.svg?siteid=300000005&locale=en_GB&3ec60977',
        description: 'Hotels.com UK',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'uk.hotels.com',
      searchParams: {
        pos: 'HCOM_UK',
        locale: 'en_GB',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },

  'us-hcom': {
    branding: {
      logo: {
        url: 'https://www.hotels.com/_dms/header/logo.svg?siteid=300000001&locale=en_US&3ec60977',
        description: 'Hotels.com US',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.hotels.com',
      searchParams: {
        pos: 'HCOM_US',
        locale: 'en_US',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
    },
  },
};

export { hotelsSearchWidgetConfig };
